import { useNavigate } from "react-router-dom";
import { Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import BackIcon from "assets/icons/back.svg";
import { isYeloCheckoutSession, partnerHomePath } from "utils/partnerSession.util";

export default function FormHeader({ page, prevPage }: any) {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const { t } = useTranslation("translation");

  return (
    <div className="form-header" style={{ marginBottom: "6px" }}>
      <Container maxWidth="lg">
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          {/* <ArrowBackIosNewIcon
            style={{
              marginBottom: "2px",
              padding: "4px 4px 4px 0",
              cursor: " pointer",
            }}
            className={i18n.language === "ar" ? "rotate" : ""}
            onClick={
              page === 1
                ? () =>
                    navigate(isYeloCheckoutSession() ? partnerHomePath() : "/")
                : () => prevPage()
            }
          /> */}

          <img
            src={BackIcon}
            alt="<"
            width={"40px"}
            height={"40px"}
            className={i18n.language === "ar" ? "rotate" : ""}
            onClick={
              page === 1
                ? () =>
                    navigate(isYeloCheckoutSession() ? partnerHomePath() : "/")
                : () => prevPage()
            }
          />
          <Typography
            width={"100%"}
            fontWeight={600}
            fontSize={"16px"}
            color={"#520A76"}
            textAlign={"center"}
            marginRight={"46px"}
          >
            {page === 1
              ? t("selectVehicle")
              : page === 2
              ? t("additionalInformation")
              : t("Review Booking")}
          </Typography>
        </Stack>
      </Container>
    </div>
  );
}
